/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionMatchEvidence } from './CompetitionMatchEvidence';
import {
    CompetitionMatchEvidenceFromJSON,
    CompetitionMatchEvidenceFromJSONTyped,
    CompetitionMatchEvidenceToJSON,
    CompetitionMatchEvidenceToJSONTyped,
} from './CompetitionMatchEvidence';

/**
 * 
 * @export
 * @interface CompetitionScoreSubmission
 */
export interface CompetitionScoreSubmission {
    /**
     * 
     * @type {string}
     * @memberof CompetitionScoreSubmission
     */
    submittedBy: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionScoreSubmission
     */
    participantId: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionScoreSubmission
     */
    participant1Score: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionScoreSubmission
     */
    participant2Score: number;
    /**
     * 
     * @type {Array<CompetitionMatchEvidence>}
     * @memberof CompetitionScoreSubmission
     */
    evidence?: Array<CompetitionMatchEvidence>;
    /**
     * 
     * @type {number}
     * @memberof CompetitionScoreSubmission
     */
    submittedAt: number;
}

/**
 * Check if a given object implements the CompetitionScoreSubmission interface.
 */
export function instanceOfCompetitionScoreSubmission(value: object): value is CompetitionScoreSubmission {
    if (!('submittedBy' in value) || value['submittedBy'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('participant1Score' in value) || value['participant1Score'] === undefined) return false;
    if (!('participant2Score' in value) || value['participant2Score'] === undefined) return false;
    if (!('submittedAt' in value) || value['submittedAt'] === undefined) return false;
    return true;
}

export function CompetitionScoreSubmissionFromJSON(json: any): CompetitionScoreSubmission {
    return CompetitionScoreSubmissionFromJSONTyped(json, false);
}

export function CompetitionScoreSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionScoreSubmission {
    if (json == null) {
        return json;
    }
    return {
        
        'submittedBy': json['submittedBy'],
        'participantId': json['participantId'],
        'participant1Score': json['participant1Score'],
        'participant2Score': json['participant2Score'],
        'evidence': json['evidence'] == null ? undefined : ((json['evidence'] as Array<any>).map(CompetitionMatchEvidenceFromJSON)),
        'submittedAt': json['submittedAt'],
    };
}

export function CompetitionScoreSubmissionToJSON(json: any): CompetitionScoreSubmission {
    return CompetitionScoreSubmissionToJSONTyped(json, false);
}

export function CompetitionScoreSubmissionToJSONTyped(value?: CompetitionScoreSubmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submittedBy': value['submittedBy'],
        'participantId': value['participantId'],
        'participant1Score': value['participant1Score'],
        'participant2Score': value['participant2Score'],
        'evidence': value['evidence'] == null ? undefined : ((value['evidence'] as Array<any>).map(CompetitionMatchEvidenceToJSON)),
        'submittedAt': value['submittedAt'],
    };
}

